import React from 'react';
import { connect } from 'react-redux'
import { chunk, keys, sortBy } from 'lodash'
import { Link } from 'react-router-dom'
import './index.css'

class DataExplorerTopic extends React.Component {
  render() {
    const { indicators } = this.props
    const indicatorsCodes = sortBy(keys(indicators).filter(code => indicators[code].shortTitle), i => indicators[i].shortTitle)
    const splitIndicators = chunk(indicatorsCodes,  (indicatorsCodes.length/3)+1)

    return (
      <div>
        <h2 className="f2 lh-title text-orange">Topics</h2>
        { splitIndicators.map((column, i) => (
          <div key={i} className="fl w-third pa1">
            { column.map(indicator => (
              <div key={indicator}>
                <Link className="no-underline underline-hover text-blue Topics__topic" to={`/topics/${indicator}`} >{ indicators[indicator].shortTitle }</Link>
              </div>
            )) }
          </div>
        )) }
      </div>
    )
  }
}

const mapStateToProps = state => ({
  indicators: state.indicators,
})

export default connect(mapStateToProps)(DataExplorerTopic)



// WEBPACK FOOTER //
// ./src/pages/DataExplorerTopics/index.js